import React , {Fragment} from 'react';
import _ from 'lodash';
import { Alert, Database, UserManager } from '../Managers/exports';
import { withSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators'
import { AUTHENTICATION_STATUS } from '../Constants';
import { Home } from './Home';
import { Modal } from '../Components/Modal/Modal';


 class Root extends React.Component{
    state = {
        alerts: [],
        user: {},
        ready: false,
        auth_status: AUTHENTICATION_STATUS.unknown,
        displayedPage: <></>
    }


    leaving = new Subject()
    componentDidMount(){
        // this component should never unmount.
        // but just incase we do
        // unsubscribe???
        Alert._getAlerts()
        .pipe(takeUntil(this.leaving))
        .subscribe(this.updateAlerts)

        UserManager.checkValidProfile()
        .then(user => this.setState({user}))
        .catch(e => _.noop())
        
    }
    componentWillUnmount(){
        this.leaving.next()
    }


    updateAlerts = (newAlert) => {
        const {message, variant, anchorOrigin, actionConfig} = newAlert
        let action 
        if(actionConfig){
            let first = (key) => {
                this.props.closeSnackbar(key)
                // alert(key)
                actionConfig[0].onPress()
            }
            let second = (key) => {
                this.props.closeSnackbar(key)
                actionConfig[1].onPress()
            }
            action = key => (
                <Fragment>
                    <Button onClick={() => first(key)}>
                        {actionConfig[0].text}
                    </Button>
                    <Button onClick={() => second(key)}>
                        {actionConfig[1].text}
                    </Button>
                </Fragment>
            );
        }
   
        this.props.enqueueSnackbar(
            message, 
            {
                variant,
                anchorOrigin,
                action
            }) 
        } 
    


    renderAlerts = () => {
        let {alerts} = this.state
        
        return(
        _.map(alerts, a => {
            return a
        })
        )
    }

    render(){
        const { user, ready, auth_status} = this.state
        return(
            <Router>
                <Switch>
                    
                    <Route path="/">
                        <Modal />
                        <Home />
                        
                    </Route>
                    
                </Switch>
            </Router>
        )

    }
 }


export default withSnackbar(Root)